export default "__VITE_ASSET__BVv4WY9o__"